import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import {FontUpgrade} from 'wix-style-react';

import {createErrorReporterSentryAdapter} from '@wix/premium-bricks-services';
import {TranslateProvider} from '@wix/premium-bricks-translate';
import {wixAxiosConfig} from '@wix/wix-axios-config';

import {App} from './components/App';
import {ErrorBoundary} from './components/ErrorBoundary';
import {ServicesProvider} from './providers';

createErrorReporterSentryAdapter.initSentry({
  appName: window.__STATICS_APP_NAME__,
  version: window.__STATICS_APP_VERSION__,
  dsn: 'https://1ef0fc9afbe94ee291acc79ea8e35a08@sentry.wixpress.com/42',
  debug: window.__DEBUG__,
  user: {
    id: window.__USER_GUID__ || 'not_authorized',
  },
  tags: {
    isAuthorized: String(window.__IS_AUTHORIZED__),
    locale: window.__LOCALE__,
  },
});

const baseURL = window.__BASEURL__;
const locale = window.__LOCALE__;
const reCaptchaSiteKey = window.__RE_CAPTCHA_SITE_KEY__;
const isAuthorized = window.__IS_AUTHORIZED__;
const getDynamicMessages = (localeToLoad: string) =>
  import(/* webpackChunkName: "whois_web_[request]" */ `./locales/whois-web/messages_${localeToLoad}.json`);

window.recaptchaOptions = {
  lang: locale,
};

wixAxiosConfig(axios, {baseURL});

ReactDOM.render(
  <TranslateProvider locale={locale} translations={getDynamicMessages}>
    <ErrorBoundary>
      <ServicesProvider>
        {() => (
          <FontUpgrade>
            <App locale={locale} reCaptchaSiteKey={reCaptchaSiteKey} isAuthorized={isAuthorized} />
          </FontUpgrade>
        )}
      </ServicesProvider>
    </ErrorBoundary>
  </TranslateProvider>,
  document.getElementById('root'),
);
